import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./AuthTheme.css";
import API_BASE_URL from "../config";
import PasswordInput from "../components/PasswordInput";
import { BsCheckCircleFill, BsXCircleFill, BsPersonPlusFill } from "react-icons/bs";

export default function SetupPassword() {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [loading, setLoading] = useState(false);
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setMessage("Invalid or missing verification token.");
      setMessageType("error");
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) {
      setMessage("Please enter a new password.");
      setMessageType("error");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/setup-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        setMessageType("success");
      } else {
        setMessage(data.error);
        setMessageType("error");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pf-auth pf-auth--center">
      <div className="pf-shell">
        <div className="pf-card">
          <div className="pf-card-icon"><BsPersonPlusFill /></div>
          <div>
            <h1 className="pf-title">Set your password</h1>
            <p className="pf-sub">Create a password to finish setting up your account.</p>
          </div>

          {message && (
            <div className={`pf-msg ${messageType === "success" ? "pf-msg--ok" : "pf-msg--err"}`}>
              {messageType === "success" ? <BsCheckCircleFill /> : <BsXCircleFill />} {message}
            </div>
          )}

          <form className="pf-form" onSubmit={handleSubmit}>
            <div className="pf-field">
              <label htmlFor="sp-pw">Password</label>
              <PasswordInput id="sp-pw" placeholder="Min 8 characters" value={password}
                onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" required />
            </div>
            <button type="submit" className="pf-btn" disabled={loading}>
              {loading ? "Setting up..." : "Set password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
